import Swiper from 'swiper';
import { Pagination, Keyboard, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function(){
    // init carousel
    const carouselEl = document.querySelector('.about-us-swiper');

    const AboutUsCarousel = new Swiper(carouselEl, {
        modules: [Pagination, Keyboard, Autoplay],
        loop: true,
        keyboard: {
            enabled: true
        },
        autoplay: {
            delay: 6000,
            pauseOnMouseEnter: true
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        on: {
            'afterInit': function(swiper){
                // stop on load
                swiper.autoplay.stop();
            }
        }
    });

    // observe for carousel
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if ( entry.isIntersecting && entry.intersectionRatio >= 0.5 ){
                // play when scroll on
                AboutUsCarousel.autoplay.start();
            }
            else
            {
                // pause when scroll off
                AboutUsCarousel.autoplay.stop();
            }
        });
    }, 
    {
        threshold: 0.5
    });

    observer.observe(carouselEl);
});